var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6302 19.79C7.1102 21 8.9402 21.8 10.9502 22L10.9502 19.98C9.4902 19.8 8.1602 19.22 7.0502 18.36L5.6302 19.79ZM4.0202 13.05L2.0002 13.05C2.2002 15.06 3.00019 16.89 4.2102 18.37L5.6402 16.95C4.7802 15.84 4.2002 14.51 4.0202 13.05ZM5.6402 7.15L4.2102 5.72C3.0002 7.2 2.2002 9.04 2.0002 11.04L4.0202 11.04C4.2002 9.59 4.7802 8.26 5.6402 7.15ZM10.9502 4.12L10.9502 2.1C8.9402 2.3 7.1102 3.1 5.6302 4.31L7.0602 5.74C8.1602 4.88 9.4902 4.3 10.9502 4.12ZM8.3602 13.46L10.9502 10.88L10.9502 17.05L12.9502 17.05L12.9502 10.88L15.5402 13.47L16.9502 12.05L11.9502 7.05L6.9502 12.05L8.3602 13.46ZM12.9502 4.12L12.9502 2.1C18.0002 2.6 21.9502 6.86 21.9502 12.05C21.9502 17.24 18.0002 21.5 12.9502 22L12.9502 19.98C16.9002 19.49 19.9502 16.13 19.9502 12.05C19.9502 7.97 16.9002 4.61 12.9502 4.12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.b3f5aab0f587f6f71d8f5f0a97321573.svg";
export { ForwardRef as ReactComponent };